export default function AccountDisabledPage() {

    return (
        <div className="container">
            <div className="row justify-content-center">
            <div className="col-lg-5">
                <div className="card mt-5">
                <div className="card-header pt-4 pb-4 text-center bg-primary">
                    <h1 className="text-white">Oops!</h1>
                </div>
                <div className="card-body p-4">
                    <div className="text-center">
                    <h1 className="text-error mt-4">Your account has been disabled</h1>
                    <h4 className="text-uppercase text-danger mt-3">Please contact your administrator</h4>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    );
}